var exports = {
  "D": "Box_0__yXj0aa",
};

module.exports = exports;
